import React from 'react';

export const BenefitValueTableColumn = (props) => {
    const {
        Value:value,
        suffix = ''
    } = props;
    
    const numberFormatter = new Intl.NumberFormat({
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const formattedValue = value != null ? numberFormatter.format(value) + (suffix ? ` ${suffix}` : '') : null;
    
    return <span>{formattedValue ?? 'N/A'}</span>;
}
